{
  "page": {
    "documentTitle": "Sign contract — Muntaha Al-Injaz",
    "tagline": "Online contract signing",
    "title": "Sign the contract",
    "noToken": "The signing link is incomplete. Open the link from the email exactly as sent.",
    "number": "Contract no.",
    "validUntil": "Link valid until {{date}}",
    "intro": "Hello {{name}}, read every clause to the end, then accept the terms, type your name and draw your signature below.",
    "hash": "Contract text fingerprint (SHA-256):"
  },
  "document": {
    "table": "Table",
    "signatures": "Signatures",
    "agency": "First party | Agency",
    "coordinator": "Second party | Coordinator",
    "notSigned": "Not signed yet",
    "stamp": "Agency stamp"
  },
  "form": {
    "title": "Sign and approve",
    "accept": "I have read all the terms of this contract and accept them",
    "scrollFirst": "Scroll to the end of the contract to enable acceptance",
    "name": "Full name",
    "nameHint": "Type your name as on your ID",
    "signature": "Signature",
    "signatureLabel": "Signature drawing area",
    "legal": "By pressing “Sign and approve” you sign this contract electronically. We keep the time, IP address, device and the text fingerprint as evidence, and email you a PDF copy.",
    "submit": "Sign and approve",
    "signing": "Signing…",
    "errors": {
      "accept": "Accept the contract terms first",
      "name": "Type your full name",
      "signature": "Draw your signature inside the box"
    }
  },
  "signed": {
    "title": "Contract signed",
    "body": "Thank you {{name}}, contract {{number}} is signed and approved. A PDF copy was emailed to you.",
    "download": "Download contract PDF",
    "preparing": "Preparing the PDF copy…"
  },
  "settings": {
    "title": "Coordinator contract",
    "ready": "Ready: contracts can be sent to coordinators for online signing.",
    "notReady": "Add the agency signatory name and draw the agency signature to enable sending contracts.",
    "contractTitle": "Contract title",
    "linkDays": "Signing link validity (days)",
    "linkDaysHint": "1 to 30 days",
    "signatoryName": "Agency signatory name",
    "signatoryTitle": "Agency signatory title",
    "template": "Contract text",
    "templateHint": "Markdown is supported (### headings and tables). Placeholders in { } are filled for each coordinator when sending; tap a placeholder to insert it.",
    "placeholders": "Placeholders",
    "edit": "Edit",
    "preview": "Preview",
    "save": "Save contract text",
    "saved": "Contract settings saved",
    "agencySignature": "Agency signature",
    "agencySignatureHint": "Draw it or upload an image once; it appears with the stamp on every new contract.",
    "redraw": "Change signature",
    "saveSignature": "Save signature",
    "signatureSaved": "Agency signature saved",
    "cancel": "Cancel",
    "stamp": "Agency stamp",
    "stampHint": "The chosen stamp is placed next to the agency signature on every contract sent from now on; contracts already sent do not change.",
    "stampCustom": "Uploaded stamp",
    "stampNone": "No stamp",
    "stampUpload": "Upload another stamp",
    "stampSaved": "Stamp saved",
    "noPlatformsTable": "The contract text has no {platforms_table} placeholder, so partner platforms and accounts won't appear in Annex B. Add it where the handover table goes."
  },
  "tab": {
    "hint": "Contracts sent for online signing and their status.",
    "send": "Send contract",
    "setupMissing": "The coordinator contract setup is incomplete (agency signatory and signature).",
    "openSettings": "Open settings",
    "caption": "Contracts",
    "empty": "No contracts",
    "emptyHint": "Send a contract for the coordinator to read and sign through a personal link.",
    "columns": {
      "number": "Contract no.",
      "status": "Status",
      "sent": "Sent",
      "viewed": "Viewed",
      "signed": "Signed"
    },
    "view": "View",
    "resend": "Resend",
    "cancel": "Cancel",
    "confirmCancel": "Cancel contract {{number}}? The signing link will stop working.",
    "resent": "A new link was sent; the previous one no longer works",
    "cancelled": "Contract cancelled",
    "annex": "Annex",
    "contract": "Contract"
  },
  "send": {
    "title": "Send a contract for signing",
    "description": "Review the contract filled for this coordinator, edit it if needed, then email the signing link. Any contract still waiting for this coordinator's signature is cancelled.",
    "agreement": "Agreement",
    "agreementStatus": {
      "current": "current from",
      "scheduled": "starts"
    },
    "contractTitle": "Contract title",
    "body": "Contract text",
    "editHint": "Edits here apply to this contract only, not to the template in settings.",
    "submit": "Send contract",
    "sending": "Sending…",
    "sent": "Contract {{number}} sent for signing"
  },
  "view": {
    "title": "Contract",
    "downloadPdf": "Download PDF",
    "evidence": "Signing evidence",
    "sentTo": "Sent to",
    "ip": "IP address",
    "device": "Device and browser",
    "hash": "Text fingerprint SHA-256",
    "method": "Signature method",
    "methods": {
      "drawn": "Drawn",
      "uploaded": "Uploaded image"
    }
  },
  "portal": {
    "title": "My contracts",
    "signedOn": "Signed on {{date}}",
    "awaiting": "Waiting for your signature — open the link in your email"
  },
  "accounts": {
    "title": "Delivered platform accounts (Annex B)",
    "hint": "The username or account number on each partner platform in the contract. Passwords are never recorded; hand them over separately. Shown in new contracts and annexes.",
    "none": "No platform is in the contract. Tick “Include in the coordinator contract” on a partner.",
    "placeholder": "Username",
    "save": "Save",
    "saved": "Account saved",
    "deliveredOn": "Delivered on {{date}}",
    "mine": "My platform accounts",
    "mineHint": "Passwords are not stored in the system; the agency gives them to you separately."
  }
}
